module.exports = __webpack_public_path__ + "9d6c1942df78f311b355af245704ac3f.pdf";